import PrivateRoutes from 'routes/PrivateRoutes';

import NotFound from 'components/NotFound';
import PatientPortal from 'components/Patient';
import PatientDashboard from 'components/Patient/Dashboard/PatientDashboard';
import PatientInvoicesContainer from 'components/Patient/Invoices/Container';
import PatientMedicalRecords from 'components/Patient/MedicalRecords';
import PatientTreatmentPlans from 'components/Patient/TreatmentPlans/PatientTreatmentPlans';
import AccountContainer from 'components/Patient/account/indexContainer';
import PatientAppointments from 'components/Patient/appointments';
import PatientDocumentsForPractice from 'components/Patient/documents/DocumentsForPractice';
import PatientDocuments from 'components/Patient/documents/PatientDocuments';
import PatientForms from 'components/Patient/forms/PatientForms';
import PatientConversation from 'components/Patient/inbox/PatientConversation';
import PatientInbox from 'components/Patient/inbox/inbox';
import PatientMedications from 'components/Patient/medications';
import PatientPayments from 'components/Patient/payments';
import PatientQuestionnaires from 'components/Patient/questionnaires';
import PatientReferrals from 'components/Patient/referrals';
import PatientSuperbills from 'components/Patient/superbills';
import Orders from 'components/practice/PracticeIQueue/Orders/Orders';

const PATIENT_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="" />,
    children: [
      {
        path: 'myportal',
        element: <PatientPortal />,
        children: [
          {
            path: '',
            element: <PatientDashboard />
          },
          {
            path: 'inbox',
            element: <PatientInbox />
          },
          {
            path: 'inbox/:myPortalPractice',
            element: <PatientConversation />
          },
          {
            path: 'medical-records',
            element: <PatientMedicalRecords />
          },
          {
            path: 'treatment-plans',
            element: <PatientTreatmentPlans />
          },
          {
            path: 'appointments',
            element: <PatientAppointments />
          },
          {
            path: 'payments',
            element: <PatientPayments />
          },
          {
            path: 'questionnaires',
            element: <PatientQuestionnaires />
          },
          {
            path: 'medications',
            element: <PatientMedications />
          },
          {
            path: 'referrals',
            element: <PatientReferrals />
          },
          {
            path: 'superbills',
            element: <PatientSuperbills />
          },
          {
            path: 'documents',
            element: <PatientDocuments />
          },
          {
            path: 'documents/:myPortalPractice',
            element: <PatientDocumentsForPractice />
          },
          {
            path: 'account',
            element: <AccountContainer />
          },
          {
            path: 'invoices',
            element: <PatientInvoicesContainer />
          },
          {
            path: 'forms',
            element: <PatientForms />
          },

          {
            path: 'orders',
            element: <Orders fromPatient />
          },
          {
            path: '*',
            element: <NotFound portal="myportal" />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default PATIENT_DASHBOARD;
